import store from '@/store';
import { GETTER_USER_PERMISSIONS, STORE_USER_NAME } from '@/store_constants/user';

export function checkUserPermissions(permissions = []) {
	const { userPermissions } = getUserContext();

	return hasAllPermissions(permissions, userPermissions);
}

function getUserContext() {
	const getterUserPermissions = `${STORE_USER_NAME}/${GETTER_USER_PERMISSIONS}`;
	const userPermissions = store.getters[getterUserPermissions] || [];

	return { userPermissions };
}

function hasAllPermissions(requiredPermissions, userPermissions) {
	if (requiredPermissions.length === 0) return false;

	return requiredPermissions.every(permission => userPermissions.some(({ codename }) => codename === permission));
}

export function convertPermissionsListToMap(permissions) {
	const permissionsMap = {};

	permissions.forEach(permission => {
		const category = toCamelCase(permission.category);
		const codename = toCamelCase(permission.codename);

		if (!permissionsMap[category]) permissionsMap[category] = {};

		permissionsMap[category][codename] = permission.codename;
	});

	return permissionsMap;
}

function toCamelCase(str) {
	return str.replace(/_([a-z])/g, (match, firstLetter) => firstLetter.toUpperCase());
}
